import React from "react"
import { EDashboardDetailType, IDashboardChartHierarchyData } from "../../models"
import { CircularProgress, Drawer, Card, CardHeader, FontIcon, Tab, Tabs } from "material-ui"
import AppStateStore from "../../stores/AppStateStore"
import HierarchySettingsStore from "../../stores/HierarchySettingsStore"
import * as hierarchyHelper from "../../helpers/hierarchyHelper"
import ReactEcharts from "echarts-for-react"
import { grey700 } from "material-ui/styles/colors"
import * as hierarchySettingsActions from "../../actions/HierarchySettingsActions"
import strings from "../../localization/strings"
import { blue700, orange700, red700 } from "material-ui/styles/colors"
interface IProps {
    open: boolean
    loading: boolean
    chartType: EDashboardDetailType
    hierarchyData: IDashboardChartHierarchyData[]
    handleClose(): void
    handleChangeActivatedTab(activatedTab: EDashboardDetailType): void
}

const DashboardBarChartDrawer: React.SFC<IProps> = (props: IProps) => {
    const option = {
        xAxis: {
            max: "dataMax",
            show: false
        },
        yAxis: {
            type: "category",
            data: props.hierarchyData.map(i => i.HierarchyName),
            axisLine: { show: false },
            axisTick: { show: false },
            axisLabel: {
                inside: true,
                fontSize: 16,
                fontWeight: "bold",
                verticalAlign: "top",
                padding: [-38, 0, 0, -8],
                color: grey700
            },
        },
        series: [{
            type: "bar",
            data: props.hierarchyData.map(i =>
                props.chartType === EDashboardDetailType.WorkingEmployee ?
                    i.WorkingEmployee :
                    props.chartType === EDashboardDetailType.ApproachingOT ?
                        i.ApproachingOT :
                        i.OT
            ),
            label: {
                show: true,
                fontSize: 16,
                fontWeight: "bold",
                position: "right",
                color: grey700
            },
            barWidth: 40,
            barMinHeight: 1,
            color: props.chartType === EDashboardDetailType.WorkingEmployee ?
                blue700 :
                props.chartType === EDashboardDetailType.ApproachingOT ?
                    orange700 :
                    red700,
        }]
    }

    const handleBarClick = (e) => {
        const clickedItem = props.hierarchyData[e.dataIndex] as IDashboardChartHierarchyData
        hierarchySettingsActions.receiveHierarchyGlobalItemId(clickedItem.HierarchyId)
        props.handleChangeActivatedTab(props.chartType)

        // if clicked item has not any child hierarchy, let's close drawer
        hierarchyHelper.getChildHierarchyItems(clickedItem.HierarchyId).length === 0 &&
            props.handleClose()
    }

    const hierarchyDefinition = hierarchyHelper.getHierarchyDefinitionByLevel(hierarchyHelper.getHierarchyDefinitionLevelByHierarchyItemId(HierarchySettingsStore.getGlobalLevelItemFilterId()) + 1)
    return (
        <Drawer
            open={props.open}
            width={750}
            style={{ maxWidth: 750 }}
            openSecondary
            docked={false}
            overlayStyle={{ zIndex: 1500 }}
            containerStyle={{
                zIndex: 1500,
                opacity: props.open ? 1 : 0,
                transition: "opacity 200ms, transform 450ms cubic-bezier(0.23, 1, 0.32, 1) 0ms"
            }}
            onRequestChange={props.handleClose}
        >
            {props.open &&
                <div>
                    <Card style={{ boxShadow: "none" }}>
                        <CardHeader
                            style={{ backgroundColor: AppStateStore.getDrawerHeaderColor(), height: 90, textAlign: "center" }}
                            title={
                                <h2>{props.chartType === EDashboardDetailType.WorkingEmployee ?
                                    strings.Working_Employees :
                                    props.chartType === EDashboardDetailType.ApproachingOT ?
                                        strings.Approaching_Overtime :
                                        strings.Overtime}</h2>
                            }
                            children={
                                <FontIcon
                                    onTouchTap={props.handleClose}
                                    className="fa fa-close"
                                    style={{ cursor: "pointer", fontSize: 25, color: "white", position: "absolute", top: 35, left: 700 }}
                                />
                            }
                            titleColor={"white"}
                        />
                    </Card>
                    <Tabs>
                        <Tab label={hierarchyDefinition && hierarchyDefinition.Label} value="label">
                            <div style={{ height: "calc(100vh - 140px)", overflowY: "auto" }}>
                                {props.loading ?
                                    <div className="spinner">
                                        <CircularProgress />
                                    </div> :
                                    <ReactEcharts
                                        style={{ height: props.hierarchyData.length * 70 + 140 }}
                                        option={option}
                                        onEvents={{ 'click': handleBarClick }}
                                    />
                                }
                            </div>
                        </Tab>
                    </Tabs>
                </div>
            }
        </Drawer>
    )
}

export default DashboardBarChartDrawer
